import React, {useRef} from 'react'

import noop from 'lodash/noop'
import {Transition} from 'react-transition-group'

import cn from '../../../../commons/src/libs/class-names'

import chevronDownIcon from '../../../../commons/src/assets/icons/chevron-down.svg'

import Icon from '../../../../commons/src/components/icon'

const KEY_ENTER = 13

export interface Props {
  classNames?: string[]
  title: string
  children: React.ReactNode
  isOpen?: boolean
  onChange?: (isOpen: boolean) => void
}

const AccordionItem = ({classNames, title, children, isOpen = false, onChange = noop}: Props) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === KEY_ENTER) {
      onChange(!isOpen)
    }
  }

  return (
    <Transition
      in={isOpen}
      nodeRef={contentRef}
      addEndListener={done => {
        if (contentRef.current) {
          contentRef.current.addEventListener('transitioncancel', done, false)
          contentRef.current.addEventListener('transitionend', done, false)
        }
      }}
      onEntering={() => {
        if (contentRef.current) {
          contentRef.current.style.height = 'auto'
          const {height} = contentRef.current.getBoundingClientRect()
          contentRef.current.style.height = '0'
          // Trigger reflow
          contentRef.current.scrollTop // eslint-disable-line no-unused-expressions
          contentRef.current.style.height = `${height}px`
        }
      }}
      onEntered={() => {
        if (contentRef.current) {
          contentRef.current.style.height = 'auto'
        }
      }}
      onExiting={() => {
        if (contentRef.current) {
          contentRef.current.style.height = 'auto'
          const {height} = contentRef.current.getBoundingClientRect()
          contentRef.current.style.height = `${height}px`
          // Trigger reflow
          contentRef.current.scrollTop // eslint-disable-line no-unused-expressions
          contentRef.current.style.height = '0'
        }
      }}
    >
      {state => (
        <section className={cn('AccordionItem', {[state]: !!state, isOpen}, classNames)}>
          <header
            className="AccordionItem__header"
            role="button"
            tabIndex={0}
            onClick={() => onChange(!isOpen)}
            onKeyDown={handleKeyDown}
          >
            <h3 className="AccordionItem__title">{title}</h3>
            <div className="AccordionItem__toggle">
              <Icon source={chevronDownIcon} block />
            </div>
          </header>
          <div className="AccordionItem__content" ref={contentRef}>
            <div className="AccordionItem__innerContent">{children}</div>
          </div>
        </section>
      )}
    </Transition>
  )
}

export default AccordionItem
